export class GetKxAccommodationOffersForApplicantResponse {
    StatusDescription: string;
    StatusFlag: string;
    HasOfferDependingOnAppTypeID: boolean;
}